import { Api } from 'utils';

class UserService {
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/users',params),
		download: async (params?: any) => Api.createResponse('admin/users/download',params),
		delete: async (params?: any) => Api.createResponse('admin/users/delete',params),
		update: async (params?: any) => Api.createResponse('admin/users/update',params),
		getPlan: async (params?: any) => Api.createResponse('admin/users/get-plan',params),
		assignPlan: async (params?: any) => Api.createResponse('admin/users/assign-plan',params),
		bulkDelete: async (params?: any) => Api.createResponse('admin/users/bulk-delete',params),
		changePassword: async (params: { user_id: number, new_password: string }) =>
			Api.createResponse('admin/users/change-password',params),
	}
}

export default UserService;